import axiosIns from '@/libs/axios'

const ROOT_URL = '/data/brands'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      title: null,
      title_content: null,
      content: null,
      seo_title: null,
      seo_description: null,
      seo_keywords: null,
      cta_title: null,
      cta_text: null,
      cta_button: null,
      cta_url: null,
      ordering: null,
      slug: null,
      id_users: null,
      mediaData: {},
      cta_mediaData: {},
      image: null,
      thumb: null,
      image_webp: null,
      thumb_webp: null,
      cta_image: null,
      cta_thumb: null,
      cta_image_webp: null,
      cta_thumb_webp: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        title_content: null,
        content: null,
        seo_title: null,
        seo_description: null,
        seo_keywords: null,
        cta_title: null,
        cta_text: null,
        cta_button: null,
        cta_url: null,
        ordering: null,
        slug: null,
        id_users: null,
        mediaData: {},
        cta_mediaData: {},
        image: null,
        thumb: null,
        image_webp: null,
        thumb_webp: null,
        cta_image: null,
        cta_thumb: null,
        cta_image_webp: null,
        cta_thumb_webp: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = params
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.dataCount)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = {
        where: {
          id: Number(id),
        },
        array: false,
      }
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = postData
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
